import { render, staticRenderFns } from "./IconMenuOpSettings.vue?vue&type=template&id=87a19e62"
import script from "./IconMenuOpSettings.vue?vue&type=script&lang=js"
export * from "./IconMenuOpSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports